import {
  _Boolean,
  AnnouncementSetting,
  GetSystemSettingInfoQuery,
  GetSystemSettingInfoQueryVariables,
} from '@/API';
import { SystemSettingInfo } from '@/appsync/graphql/systemSettingInfo';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import {
  updateIsPortalEnabledFalseAndIsJobSchedulerEnabledTrue,
  createSystemSettingInfo,
} from '@/appsync/service/SystemSettingMutationService';
import { getSystemSettingInfo } from '@/graphql/queries';
import {
  _BooleanEnum2boolean,
  returnFalseIfNilElseProcess,
  ifNilThenDefaultTo,
} from '@/utils/CommonUtils';

export const getSystemSettingInfoIfNotCreate = async (
  tenant: string,
  landscape: string
): Promise<SystemSettingInfo> => {
  const systemSettingInfoData = await getSystemSettingInfoData(
    tenant,
    landscape
  );
  if (systemSettingInfoData) {
    return {
      isMultilanguageEnabled: _BooleanEnum2boolean(
        ifNilThenDefaultTo(
          systemSettingInfoData.isMultilanguageEnabled,
          '_true'
        )
      ),
      isJobSchedulerEnabled: _BooleanEnum2boolean(
        ifNilThenDefaultTo(systemSettingInfoData.isJobSchedulerEnabled, '_true')
      ),
      isPortalEnabled: returnFalseIfNilElseProcess(_BooleanEnum2boolean)(
        systemSettingInfoData.isPortalEnabled
      ),
      announcementSetting: systemSettingInfoData.announcementSetting
        ? systemSettingInfoData.announcementSetting
        : AnnouncementSetting.UseV1,
    };
  }
  if (!systemSettingInfoData) {
    await createSystemSettingInfo(tenant, landscape);
  }
  return {
    isMultilanguageEnabled: true,
    isJobSchedulerEnabled: true,
    isPortalEnabled: false,
    announcementSetting: AnnouncementSetting.UseV1,
  };
};

export const getSystemSettingInfoData = async (
  tenant: string,
  landscape: string
) => {
  const result = await graphqlQuery<
    GetSystemSettingInfoQuery,
    GetSystemSettingInfoQueryVariables
  >(getSystemSettingInfo, { tenant, landscape });
  if (result && result.getSystemSettingInfo) {
    const systemSettingInfo = result.getSystemSettingInfo;
    return {
      isMultilanguageEnabled: systemSettingInfo.isMultilanguageEnabled,
      isJobSchedulerEnabled: systemSettingInfo.isJobSchedulerEnabled,
      isPortalEnabled: systemSettingInfo.isPortalEnabled,
      announcementSetting: systemSettingInfo.announcementSetting,
    };
  }
  return null;
};

export const getIsPortalEnabledStatus = async (
  tenant: string,
  landscape: string
) => {
  const systemSettingInfoData = await getSystemSettingInfoData(
    tenant,
    landscape
  );
  if (systemSettingInfoData) {
    return returnFalseIfNilElseProcess(_BooleanEnum2boolean)(
      systemSettingInfoData.isPortalEnabled
    );
  }
  return false;
};
